<template>
  <DashboardWidget class="widget-gauge" :loading="loading" :title="title">
    <v-chart :options="chart" :autoresize="true" />
  </DashboardWidget>
</template>

<script>

import ECharts from 'vue-echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/tooltip';

export default {
  name: 'dashboard-widget-gauge',
  components: {
    DashboardWidget: () => import('../DashboardWidget'),
    'v-chart': ECharts,
  },
  computed: {
    chart () {
      const series = [];
      if (this.value > this.max) {
        series.push(this.transparentChart);
      }
      series.push(this.realChart);
      series.push(this.valueExceededChart);
      return {
        series,
      };
    },
    transparentChart () {
      const v = JSON.parse(JSON.stringify(this.baseChart));
      v.axisLine.lineStyle.color = [[1, '#fff']];
      v.pointer.show = true;
      v.axisLabel.show = false;
      return v;
    },
    realChart () {
      const v = JSON.parse(JSON.stringify(this.baseChart));
      v.data[0].value = this.value;
      v.endAngle = 3;
      v.axisLabel.show = true;
      v.pointer.show = this.value <= this.max;
      v.axisLine.lineStyle.color = [[1, '#289ad8']];
      return v;
    },
    valueExceededChart () {
      const v = JSON.parse(JSON.stringify(this.baseChart));
      v.pointer.show = false;
      v.data[0].value = this.value;
      v.startAngle = 3;
      v.endAngle = -45;
      v.axisLine.lineStyle.color = [[1, '#DC3444']];
      v.axisLabel.show = false;
      return v;
    },
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    min: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
    value: {
      type: Number,
      default: null,
    },
  },
  data () {
    return {
      loading: false,
      baseChart: {
        type: 'gauge',
        radius: '95%',
        detail: {
          formatter: '{value}',
          fontSize: 18,
          fontWeight: 'bold',
          color: '#343338',
        },
        data:
          [
            {
              value: this.value,
            },
          ],
        min: this.min,
        max: this.max,
        splitNumber: 1,
        axisLine: {
          lineStyle: {
            color: [[1, '#fff']],
            width: 15,
          },
        },
        splitLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          formatter: '{value}',
          fontSize: 12,
          padding: -10,
        },
        pointer: {
          length: '75%',
          width: 5,
        },
        itemStyle: {
          color: '#343338',
        },
        animationDelay: 500,
        animationDurationUpdate: 1500,
      },
    };
  },
};

</script>

<style lang="scss">

.widget-gauge {
  .widget-content {
    position: relative;
    .absolute {
      position: absolute;
    }
  }
  .echarts {
    width: 100%;
    height: 100%;
    > div {
      height: 100%!important;
      max-width: 100% !important;
      width: 100% !important;
      > canvas {
        max-height: 100% !important;
        left: 50%!important;
        margin: auto;
        max-width: 100% !important;
        transform: translateX(-50%);
        width: auto !important;
      }
    }
  }
}

</style>
